import { useEffect } from "react"

export const useRestoreConsent = () => {
  useEffect(() => {
    const cookieRow = document.cookie
      .split("; ")
      .find((row) => row.startsWith("faceInstituteCookie="))

    const cookieValue = cookieRow ? cookieRow.split("=")[1] : undefined

    if (cookieValue === "true") {
      const tryRestore = () => {
        if (typeof window.gtag === "function") {
          console.log(
            "[RestoreConsent] Consent accepted previously. Sending update..."
          )
          window.gtag("consent", "update", {
            ad_storage: "granted",
            analytics_storage: "granted",
            ad_user_data: "granted",
            ad_personalization: "granted",
          })
        } else {
          console.log("[RestoreConsent] gtag() not ready. Retrying...")
          setTimeout(tryRestore, 200)
        }
      }

      tryRestore()
    } else {
      console.log(
        "[RestoreConsent] No accepted cookie found or consent was declined."
      )
    }
  }, [])
}
